import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "dialog-tickets",
  templateUrl: "dialog-tickets.html",
  styleUrl: "dialog-tickets.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, DatePipe, MatTooltipModule, TranslatePipe, MatDialogClose],
})
export class DialogTickets {
  data = inject(MAT_DIALOG_DATA);

  protected dialogRef = inject(MatDialogRef<DialogTickets>);

  // TODO: can we use one of the datetime pipes here instead?
  protected formattableDate(d: string | number) {
    if (typeof d === "string") {
      return new Date(d).getTime();
    } else if (typeof d === "number") {
      return d * 1000;
    }
    return d;
  }
}
